import React from 'react';
import { Sparkles, BadgeCheck, Leaf, PiggyBank } from 'lucide-react';
import { useT } from '../i18n/LanguageContext';

const icons = [Sparkles, BadgeCheck, Leaf, PiggyBank];

export default function Reasons() {
  const { t } = useT();

  const items = [1, 2, 3, 4].map((i) => ({
    Icon: icons[i - 1],
    stat: t(`reasons.${i}.stat`),
    label: t(`reasons.${i}.label`),
    desc: t(`reasons.${i}.desc`),
  }));

  return (
    <section id="about" className="py-24 uc-mint-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="uc-kicker mb-3">{t('reasons.kicker')}</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1a2851]">
            {t('reasons.heading1')} <span className="text-[#4dbfae]">{t('reasons.heading2')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((r, i) => {
            const Icon = r.Icon;
            return (
              <div key={i} className="uc-lift text-center px-6 py-10 rounded-2xl bg-white border border-[#eef6f4]">
                <div className="w-16 h-16 mx-auto rounded-full bg-[#f2fbf9] border-2 border-[#4dbfae] flex items-center justify-center mb-5 text-[#4dbfae]">
                  <Icon size={26} />
                </div>
                <h3 className="font-serif text-2xl font-bold text-[#1a2851]">{r.stat}</h3>
                <p className="text-sm font-semibold text-[#4dbfae] uppercase tracking-wider mb-3">{r.label}</p>
                <p className="text-sm text-[#5b6469] leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
